import { PdfGen } from '../../pdf/pdf';
import { ILayoutSingleGen } from '../layoutSingle';
import { OptsSingle } from '../optsSingle';
import { QSingle } from '@educraft/base';
import { GUtil } from '../../pdf/gutil';
import { GLabel } from '../../pdf/glabel';
import { genSingle, fixGenArray } from '../../core/genHelper';
import { genMiniLuk, drawMiniLuk, MiniLukData } from '../../pdf/board/miniLuk';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/helpers';
import '../../pdf/draw/label';

/**
 * MiniLUK (Single version)
 *
 * Layout: Landscape A4 with MiniLUK puzzle format.
 * 12 items arranged in a 2×6 grid: answers (top) and questions (bottom).
 * Mini tiles in the middle show the self-checking solution pattern.
 * Items are grouped by answer so players match questions to answers.
 *
 * Uses IGenSingle generator to create questions, then groups by answer.
 *
 * Migrated from C# EduFrame.Single.Generators.MiniLUK__Skupiny
 */

export class MiniLUK__Groups implements ILayoutSingleGen {
  protected readonly counts = new Set([6, 4, 3, 2]);

  public async generate(pdf: PdfGen, opts: OptsSingle): Promise<void> {
    const totalSheets = 1;

    for (let sIdx = 0; sIdx < totalSheets; sIdx++) {
      const page = pdf.addPage(true);

      const items = genMiniLuk<QSingle>(
        () => opts.generator.generate(opts.data),
        (item) => item.answer,
        (item) => fixGenArray(item.texts).join('|'),
        this.counts,
        opts.data.random
      );

      let font = GUtil.baseFont;

      drawMiniLuk(
        page,
        items,
        (data: MiniLukData<QSingle>) => {
          page.drawLabel(GLabel.fromText(fixGenArray(data.obj.texts)[0]), {
            rect: data.rect,
            font,
          });
        },
        (data: MiniLukData<QSingle>) => {
          page.drawLabel(GLabel.fromText(data.obj.answer), { rect: data.rect, font });
        },
        (width: number) => {
          const texts = items.map((i) => fixGenArray(i.obj.texts)[0]).filter(Boolean);
          if (texts.length > 0) {
            font = page.adjustFont(width, texts, GUtil.baseFont);
          }
        },
        opts.data
      );
    }
  }
}
